/* eslint-disable import/no-cycle */
/* eslint-disable import/prefer-default-export */
// import { createPromiseRequest } from '../../api.util';
import { hasAccessToken } from '../../../../../scanline/utils/token';
import ajax from '../../ajax';

/** ************************
 * AJAX WRAPPERS
 */

const createStubbedRequest = ({
	url,
	data: paramData,
	method = 'GET',
	aip = 'cisviewreadonly',
	isAnonymous
}) => () => {
	return new Promise((resolve, reject) => {
		setTimeout(() => {
			resolve(true);
		}, 2000);
	});
};

const createAjaxRequest = ({
	url,
	data,
	method,
	callback,
	isAnonymous,
	aip = 'cisviewreadonly'
} = {}) => () => {
	return new Promise((resolve, reject) => {
		const handleExternalCallback = (err, res) => {
			if (callback) {
				callback(err, res);
			}
		}

		const internalCallback = (err, res) => {
			handleExternalCallback(err, res);
			if (err) {
				reject(err);
			} else {
				resolve(res);
			}
		}

		ajax(url, data, method, internalCallback, isAnonymous, aip);
	})
};

/** ************************
 * MAIN
 */

export const postDeleteSurveys = (timeuuids) => {
	if (hasAccessToken()) {
		const post = createAjaxRequest({
			aip: 'cisview',
			url: '/deleteAllSurveys',
			method: 'POST',
			data: JSON.stringify({ jobguids: timeuuids }),
			isAnonymous: false,
		});

		return post();
	}
	return Promise.reject(new Error('Missing token'));
};

export const postDeleteAllReadings = (timeuuids) => {
	if (hasAccessToken()) {
		const post = createAjaxRequest({
			aip: 'cisview',
			url: '/deleteAllDatRef',
			method: 'POST',
			data: JSON.stringify({ jobguids: timeuuids }),
			isAnonymous: false,
		});

		return post();
	}
	return Promise.reject(new Error('Missing token'));
};

export const postUnsyncSurveys = (timeuuids) => new Promise(async (resolve, reject) => {
	const payloads = timeuuids.map(guid => ({ sync: false, job: guid }));

	if (hasAccessToken()) {
		const results = await Promise.allSettled(payloads.map(payload => {
			const post = createAjaxRequest({
				aip: 'cisview',
				url: '/update',
				method: 'POST',
				data: JSON.stringify(payload),
				isAnonymous: false,
			});

			return post();
		}));

		const responses = results.filter(r => r.status === 'fulfilled');
		const errors = results.filter(r => r.status !== 'fulfilled');
		if (errors.length) {
			reject(errors);
		} else {
			resolve(responses);
		}
	}
	reject(new Error('Missing token'));
});

export const postSyncSurveys = (timeuuids) => new Promise(async (resolve, reject) => {
	const payloads = timeuuids.map(guid => ({ sync: true, job: guid }));

	if (hasAccessToken()) {
		const results = await Promise.allSettled(payloads.map(payload => {
			const post = createAjaxRequest({
				aip: 'cisview',
				url: '/update',
				method: 'POST',
				data: JSON.stringify(payload),
				isAnonymous: false,
			});

			return post();
		}));

		const responses = results.filter(r => r.status === 'fulfilled');
		const errors = results.filter(r => r.status !== 'fulfilled');
		if (errors.length) {
			reject(errors);
		} else {
			resolve(responses);
		}
	}
	reject(new Error('Missing token'));
});
